const COLLECTION_KEY = "COLLECTION_KET";
export function storeSelectedCollection(collection) {
    localStorage.setItem(COLLECTION_KEY, JSON.stringify(collection));
}
export function getSelectedCollection() {
    return (JSON.parse(localStorage.getItem(COLLECTION_KEY)) || { id: "", name: "" });
}
